import React, { useEffect } from 'react';
import '../fonts/fonts.css';
import './particles.css';
import './home.css';
import './projects.css';
import Header from './header';
import grainGif from '../images/grain.gif';
import herdmateLogo from '../images/herdmateLogo.png';

function Projects({ isLoggedIn, onLogout, onLogin }) {
  useEffect(() => {
    // Particles.js initialization
    if (window.particlesJS) {
      // Initialize particles here if needed
    }
  }, []);

  return (
    <>
      <div className="grain-background" style={{ backgroundImage: `url(${grainGif})` }}></div>
      <Header isLoggedIn={isLoggedIn} onLogout={onLogout} onLogin={onLogin} />

      <p id="particles-js"></p>

      <h1 className="hHeaderP" id="frontpageContent">Other Projects</h1>
      <a href="https://www.herdmate.app/" title="HerdMate">
        <img className="projectIMG_1" src={herdmateLogo} alt="HerdMate" />
      </a>
    </>
  );
}

export default Projects;

